import React from 'react';

import ContactSupport from '../test-case/ContactSupport';
import './_test-cycle.scss';

export default function LackPermissions(): JSX.Element {
  return (
    <div className='test-cycle-permission-container'>
      <h4 className='test-cycle-permission-text'>
        We could not show you this Test Cycle. You may lack sufficient
        permissions to view it or the project may no longer exist. <br />
        Please contact your administrator or reach out to our support if the
        problem persists.
      </h4>
      <ContactSupport />
    </div>
  );
}
